
const button = {
  text: {
    submit: 'שמור',
    cancel: 'בטל',
    clearFilter: 'נקה מסננים',
    close: 'סגור',
    create: 'הוסף',
    edit: 'ערוך',
    save: 'שמור',
  },
};

export default button;
